import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import useInputs from '../../../utils/hooks/useInputs.js'
import CenterService from '../../../services/centers/center.service.js'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions.js'
import DataTableComp from '../../../components/common/data-table/DataTableComp.jsx'
import Modal from '../../../components/modal/Modal.jsx'
import useModal from '../../../utils/hooks/useModal.js'
import './centersMain.scss'
import { urlBack } from './utils/center.utils.ts'
import CenterContractsFileForm from './form/CenterContractsFileForm.tsx'
import AppButton from '../../../component/common/AppButton.tsx'
import CenterSection from './common/CenterSection.tsx'
import AppInput from '../../../component/form/AppInput.tsx'
import AppModal from '../../../component/layout/AppModal.tsx'
import { useTranslation } from 'react-i18next'
import { useDisclosure } from '@mantine/hooks'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'

const CenterContracts = () => {
  const { formatMessage: msg, formatDate: formatDateInl } = useIntl()
  const { t } = useTranslation()
  const [opened, { open, close }] = useDisclosure(false)

  const { id } = useParams()

  const [currentCenter, setCurrentCenter] = useState()
  const { inputs, onChangeInputs, updateInputs } = useInputs()
  // const [ selectedRenewalDate, setSelectedRenewalDate ] = useState()
  const [selectedFile, setSelectedFile] = useState()

  const navigate = useNavigate()

  useEffect(() => {
    getCenterData()
    getCenterDataContracts()
  }, [])

  useEffect(() => {
    dataFacade.reload()
  }, [inputs])
  useEffect(() => {
    if (!opened) getCenterDataContracts()
  }, [opened])

  const getCenterData = async () => {
    const response = await CenterService.getById(id)
    if (response) {
      setCurrentCenter(response.resp)
    }
  }

  const getCenterDataContracts = async () => {
    const response = await CenterService.contracts.getById(id)
    console.log('getCenterDataContracts', response)
    if (response) {
      updateInputs(response?.resp)
    }
  }

  const handleSave = async () => {
    const data = {
      ...inputs,
    }
    const response =
      id && id !== 'undefined'
        ? await CenterService.contracts.update({ id, body: data })
        : null
    if (response) {
      updateInputs(response?.resp)
      navigate(urlBack(inputs?.centerType))
      // navigate(mainCentersPathname.CENTERS)
    }
  }

  const openFile = (rowData) => (
    <button
      onClick={() => {
        // setSelectedFile(rowData?.file)
        // console.log('openFile', rowData)
        toggleViewer()
      }}
    >
      !!!
    </button>
  )

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'comercialDataId',
    // getAll: () => { return { resp: inputs?.renewalDate } },
    getAll: () => {
      return { resp: inputs?.files }
    },
  })

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        header: (
          <AppInput
            name="canon"
            labelh="canon"
            icon="calc"
            value={inputs?.canon}
            placeholder="canon"
            onChange={onChangeInputs}
          />
        ),
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        editMode: 'row',
        selectionMode: 'single',
        // selection: selectedCenterComercialData,
        onRowSelect: (e) => {
          setSelectedFile(e?.data)
          open()
        },
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column
          sortable
          field="description"
          header={t('description')}
          style={{ width: '90%' }}
        />,
        // <Column
        //     sortable
        //     field="fileName"
        //     header={t("filename")}
        // />,
        <Column sortable field="mimeType" header={t('type')} align="right" />,
        // <Column
        //     sortable
        //     field="file"
        //     header={t("view")}
        //     align="right"
        //     onClick={(e) => toggleViewer(e)}
        //     // body={(rowData) => openFile(rowData)}
        //     // body={({ file }) => (
        //     //     <button onClick={() => onclickPreviewPdf(file)}>
        //     //         {t("view")}
        //     //     </button>
        //     // )}
        // />,
      ]}
    />
  )

  return (
    <CenterSection
      toolbar={
        <AppToolbar
          rightSection={[
            <AppButton
              preset="back"
              onClick={() => navigate(urlBack(currentCenter?.centerType))}
            />,
            <AppButton
              preset="add"
              onClick={() => {
                setSelectedFile()
                open()
              }}
            />,
            <AppButton preset="save" onClick={handleSave} />,
          ]}
        />
      }
    >
      {dataTable}
      <AppModal
        size="xl"
        w={1480}
        miw={1480}
        opened={opened}
        close={close}
        title={t(
          selectedFile ? 'center.contracts.file' : 'center.contracts.file.add',
        )}
      >
        <CenterContractsFileForm
          centerId={id}
          selectedItem={selectedFile}
          close={close}
        />
      </AppModal>

      {/* <Modal
                isShowing={isShowing}
                maximizable
                hide={toggle}
                width="80%"
                maxWidth="800px"
                height="70%"
                title={t(selectedFile ? 'center.contracts.file' : 'center.contracts.file.add')}
                
            /> */}
    </CenterSection>
  )
}

export default CenterContracts
